import { InjectionToken } from '@angular/core';
import { COHORT_CONFIG, COHORT_CONFIG_TYPE } from './cohort.config';

export const COHORT_CONFIG_TOKEN = new InjectionToken<COHORT_CONFIG_TYPE>('COHORT_CONFIG');

export function provideCohortConfig(config = COHORT_CONFIG) {
  return { provide: COHORT_CONFIG_TOKEN, useValue: config };
}



// WEBPACK FOOTER //
// ./ts/app/home/cohort/cohort.config.token.ts